import { render, staticRenderFns } from "./ExamHighestScore.vue?vue&type=template&id=3435796d&scoped=true"
import script from "./ExamHighestScore.vue?vue&type=script&lang=js"
export * from "./ExamHighestScore.vue?vue&type=script&lang=js"
import style0 from "./ExamHighestScore.vue?vue&type=style&index=0&id=3435796d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3435796d",
  null
  
)

export default component.exports